function toggleFAQ(element) {
    let faqItem = element.parentElement;
    let faqAnswer = faqItem.querySelector(".faq-answer");
    let faqIcon = element.querySelector(".faq-icon");

    if (faqItem.classList.contains("active")) {
        faqAnswer.style.maxHeight = "0px";
        faqAnswer.style.opacity = "0";
        faqIcon.innerText = "+";
        faqItem.classList.remove("active");
    } else {
        document.querySelectorAll(".faq-item").forEach(item => {
            item.classList.remove("active");
            item.querySelector(".faq-answer").style.maxHeight = "0px";
            item.querySelector(".faq-answer").style.opacity = "0";
            item.querySelector(".faq-icon").innerText = "+";
        });

        faqItem.classList.add("active");
        faqAnswer.style.maxHeight = faqAnswer.scrollHeight + "px";
        faqAnswer.style.opacity = "1";
        faqIcon.innerText = "×";
    }

    if(!element.classList.contains("faq-question-seo")) {
        gaEvent('FAQ', [element.dataset.index, "", "", "", "", ""], false);
    }
}